import { RuleDefinition } from "../type-validator";
import { custom } from "./custom";

export const pureObject: RuleDefinition = custom((value) => [
  typeof value === "object" && value !== null && !Array.isArray(value),
  "a pure object (non-null and non-array)",
]);
